<template>
  <div>
    <ClientSummary v-model="maximizeCard" :module_id="48" />

    <vx-card title="" class="mb-4">
      <vs-row class="mt-2">
        <vs-col
          v-if="this.checkViewPermission()"
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input
              placeholder="Search"
              class="w-full"
              v-model="search"
              @keyup="searchFun"
              style="width: 100%"
            />
          </div>
          <div class="md:w-1/2 w-full p-1">
            <v-select
              placeholder="Select Student Type"
              class="w-full"
              label="name"
              :options="ClientType"
              :reduce="(item) => item.value"
              :clearable="false"
              v-model="searchPayload.client_type"
            >
            </v-select>
          </div>
          <!-- <div class="md:w-1/2 w-full p-1">
            <v-select
                append-to-body
                class="w-full"
                label="name"
                placeholder="Select Tag"
                :reduce="(option) => option.id"
                :options="tagModuleWise"
                v-model="searchPayload.tag_ids"
                :clearable="false"
                data-vv-name="tag_list"
                name="tag_list"
                multiple
            >
            </v-select>
          </div> -->
          <div class="p-1 flex">
            <vs-button
              @click="searchByfilter"
              class="includeIcon includeIconOnly"
              >Go</vs-button
            >

            <vs-tooltip text="Reset">
              <vs-button
                type="border"
                @click="resetSearch"
                icon-pack="feather"
                icon="icon-refresh-ccw"
                class="ml-2"
              ></vs-button>
            </vs-tooltip>
          </div>
          <vs-button
            class="custom-btn1"
            type="border"
            @click="handleBulkDelete"
            v-if="isRowSelected"
            >Delete</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="12"
          vs-xs="12"
          vs-justify="flex-end"
          v-if="checkManualEnrollmentPermission()"
        >
          <div class="md:w-1/2 w-full p-1">
            <UModal @afterSubmission="afterSubmission($event)" />
          </div>
        </vs-col>
      </vs-row>
      <!-- table -->
    </vx-card>
    <vx-card class="mt-2"> <h4>Admitted Students</h4> </vx-card>
    <div v-if="this.checkViewPermission()">
      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="limitedTableList"
        rowSelection="multiple"
        @row-selected="CellvalueSelectDeselect"
        @cell-clicked="cellSingleClicked"
        :enableRtl="$vs.rtl"
        colResizeDefault="true"
        :style="{ minHeight: meta.length * 48 + 75 + 'px' }"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @grid-ready="onGridReady"
        @sortChanged="sortFun"
      >
      </ag-grid-vue>
      <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
        <vs-col
          vs-xs="12"
          vs-sm="6"
          vs-lg="4"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
        >
          <!-- page limit select view -->
          <ItemsPerTableDropdown
            tableName="admission_list"
            @change="(pageLimit) => pageLimitSet = pageLimit"
          />
        </vs-col>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
          <pagination
            style="float: right"
            :meta="meta"
            @page-change="handlePageChange"
          />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>
import FullNameCell from './FullNameCell.vue'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import vSelect from 'vue-select'
import { mapGetters, mapActions } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import CellRendererActions from './CellRendererActions'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import ClientSummary from '../../analytics/summeryLIst'
import Pagination from '@/components/common/pagination'
import UModal from './UserModalCreate'
import TagShow from '../../leads/TagShow'
import {
  enrolledStudentsList,
  fetchAdmissionBySearch
} from '@/api/admission.js'
import { Tag } from '@/mixins/tag/tag'
export default {
  mixins: [Tag, PermissionMiddleware],
  data () {
    return {
      tableData: [],
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      //sayantani
      search: '',
      maximizeCard: true,
      components: {
        TagShow,
        CellRendererActions,
        FullNameCell
      },
      searchPayload: {
        client_type: null,
        tag_ids: []
      },
      searchByClientType: '',
      ClientType: [
        {
          name: 'Individual',
          value: 'individual'
        },

        {
          name: 'Parent',
          value: 'parent'
        },
        {
          name: 'Child',
          value: 'child'
        }
      ],
      platform_module_id: 48,
      gridApi: null,
      gridOptions: {
        accentedSort: true
      },
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      isRowSelected: false,
      select_filter_id: '',
      pageLimitOPtion: [
        {
          name: 5,
          value: 5
        },
        {
          name: 10,
          value: 10
        },
        {
          name: 20,
          value: 20
        }
      ],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10
      },
      pageLimitSet: null,
      students: [],
      rowData: null,
      columnDefs: null,
      //sayantani
      select1Normal: '',
      select1: 2,
      select2: 7,
      select3: 2,
      select4: 5,
      options1: [
        { text: 'IT', value: 0 },
        { text: 'Blade Runner', value: 2 },
        { text: 'Thor Ragnarok', value: 3 }
      ]
    }
  },
  components: {
    ClientSummary,
    AgGridVue,
    Pagination,
    UModal,
    TagShow,
    vSelect,
    CellRendererActions,
    FullNameCell
  },
  computed: {
    ...mapGetters(['get_client_deleted_id']),
    limitedTableList () {
      return this.tableData
    }
  },
  created () {
    this.checkPermissionForStaff()
  },
  beforeMount () {
    this.columnDefs = [
      {
        headerName: '#',
        field: 'row_index',
        filter: false,
        minWidth: 60,
        resizable: true,
        editable: false,
        sortable: false,
        valueGetter: 'node.rowIndex + 1'
      },
      {
        headerName: 'Full Name',
        field: 'fullname',
        filter: true,
        minWidth: 150,
        editable: false,
        sortable: true,
        field_type:'system',
        cellRendererFramework: 'FullNameCell',
        cellStyle: { color: 'blue' },
        suppressMovable: false
      },
         
      {
        headerName: 'First Name',
        field: 'basic_details.first_name',
        minWidth: 150,
        filter: false,
        sortable: true
      },
      {
        headerName: 'Middle Name',
        field: 'basic_details.middle_name',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Last Name',
        field: 'basic_details.last_name',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Email',
        field: 'basic_details.email',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Phone',
        field: 'basic_details.mobile',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'User Type',
        field: 'basic_details.user_type',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Address1',
        field: 'basic_details.address.address1',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Address2',
        field: 'basic_details.address.address2',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'County/State',
        field: 'basic_details.address.state',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Postcode/Zip',
        field: 'basic_details.address.zip',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Country',
        field: 'basic_details.address.country.country_name',
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'City',
        field: 'basic_details.address.city',
        filter: false,
        minWidth: 125,
        editable: false,
        sortable: true
      }
      // {
      //   headerName: 'Tags',
      //   field: 'tags',
      //   filter: false,
      //   minWidth: 125,
      //   editable: false,
      //   cellRendererFramework: 'TagShow'
      // }
      // {
      //   headerName: 'Delete',
      //   field: 'basic_details',
      //   filter: false,
      //   minWidth: 125,
      //   editable: false,
      //   cellRendererFramework: 'CellRendererActions'
      // }
    ]
  },
  watch: {

    tagSelected () {
      this.filterTagList(this.platform_module_id)
    },
    pageLimitSet () {
      this.handlePageChange(1)
    },
    get_client_deleted_id () {
      if (this.get_client_deleted_id) {
        const table = this.tableData
        const dlt_id = table.findIndex(
          (item) => item.basic_details.client_users_id === this.get_client_deleted_id
        )
        if (table[dlt_id].basic_details.user_type === 'Parent') {
          if (table[dlt_id].children.length > 0) {
            for (const chld of table[dlt_id].children) {
              const childIndex = table.findIndex(
                (item) => item.basic_details.client_users_id ===
                  chld.address.client_users_id
              )
              table.splice(childIndex, 1)
            }
            const parentIndex = table.findIndex(
              (item) => item.basic_details.client_users_id ===
                this.get_client_deleted_id
            )
            table.splice(parentIndex, 1)
          } else {
            table.splice(dlt_id, 1)
          }
        } else {
          table.splice(dlt_id, 1)
        }
        // table[dlt_id].basic_details.user_type ==='Parent'

        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.tableData = table
      }
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
  },
  methods: {
    ...mapActions(['SET_CLIENT_DELETE_ID']),
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId === 'basic_details.first_name') {
        field_name = 'first_name'
      } else if (
        colId === 'basic_details.middle_name'
      ) {
        field_name = 'middle_name'
      } else if (
        colId === 'basic_details.middle_name'
      ) {
        field_name = 'middle_name'
      } else if (
        colId === 'basic_details.last_name'
      ) {
        field_name = 'last_name'
      }  else if (
        colId === 'basic_details.email'
      ) {
        field_name = 'email'
      } else if (
        colId === 'basic_details.address.address1'
      ) {
        field_name = 'address1'
      } else if (
        colId === 'basic_details.address.address2'
      ) {
        field_name = 'address2'
      } else if (
        colId === 'basic_details.address.zip'
      ) {
        field_name = 'zip'
      } else if (
        colId === 'basic_details.address.city'
      ) {
        field_name = 'city'
      } else if (
        colId === 'basic_details.address.state'
      ) {
        field_name = 'state'
      } else if (
        colId === 'basic_details.address.country.country_name'
      ) {
        field_name = 'platform_customer_countries_id'
      }
      console.log('field_name : ', field_name)
      return field_name
    },
    async sortFun () {
      this.$vs.loading({
        text: 'Fetching enrolled Students'
      })
      try {
        const sortState = this.gridApi.getSortModel()
        console.log()
        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
        
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getCorrectFieldName(sortState[0].colId)
          this.sorting_obj.direction = sortState[0].sort


          const payload = {
            search: this.search,
            customer_id: this.$store.getters.customerId,
            limit: this.meta.limit
          }

          const { data } = await fetchAdmissionBySearch(
            payload,
            this.meta.current_page,
            this.sorting_obj
          )
       
          const table = data.data.clientUser
          this.meta = data.data.meta
          table.map((row, index) => {
            const actionData = {
              toggle: row.is_active === '1',
              view: false
            }
            Object.assign(row, { actionData })
          })
          this.tableData = table
          this.rowData = this.tableData
      
        }
      } catch (e) {

      } finally {
        this.$vs.loading.close()
      }
     
      
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        const payload = {
          search: vm.search,
          customer_id: vm.$store.getters.customerId,
          limit: vm.meta.limit
        }
        vm.meta.current_page = 1

        const { data } = await fetchAdmissionBySearch(
          payload,
          vm.meta.current_page,
          vm.sorting_obj
        )
        const table = data.data.clientUser
        vm.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        vm.students = table
        vm.tableData = vm.students
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    resetSearch () {
      this.searchPayload.client_type = null
      this.searchPayload.tag_ids = []
      this.clientList()
    },
    checkPermissionForStaff () {
      const role_permission = parseInt(localStorage.getItem('role_permission'))
      if (role_permission === 1) {
        this.schoolAdmin = true
      } else {
        this.schoolAdmin = false
        this.getModulePermission('Admission')
      }
    },
    searchByfilter () {
      this.clientList()
    },
    afterSubmission (data) {
      this.handlePageChange(1)
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      //
      return selectedData
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    handlePageChange (page) {
      if (!this.pageLimitSet) return

      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.pageLimitSet
      this.query_page.page = page
      const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({ path: '/pages/admission', query: queryPayload })
        .catch(() => {})
        .then(() => {
          document.documentElement.scrollTop = pageScroll
        })
      if (this.search != '' || this.sorting_obj.attribute != '') {
        this.searchFunPage()
      } else {
        this.clientList()
      }
    },
    async searchFunPage () {
      try {
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId,
          limit: this.meta.limit
        }
        this.$vs.loading({
          text: 'Fetching enrolled Students'
        })
        const { data } = await fetchAdmissionBySearch(
          payload,
          this.meta.current_page,
          this.sorting_obj
        )
        const table = data.data.clientUser
        this.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.is_active === '1',
            view: false
          }
          const row_index = index + 1
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
        })
        this.tableData = table
        this.fetchTag(this.platform_module_id)
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchAdmissionListBySearch () {
      try {
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId,
          limit: this.meta.limit
        }

        const { data } = await fetchAdmissionBySearch(
          payload,
          this.meta.current_page
        )
        const table = data.data.clientUser
        this.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.students = table
        this.tableData = this.students
      } catch (e) {}
    },
    cellSingleClicked (params) {
      if (params.column.colId === 'fullname') {
        this.$router
          .push({
            name: 'enrollment',
            params: { studentId: params.data.basic_details.client_users_id }
          })
          .catch(() => {})
      }
    },
    async clientList () {
      this.$vs.loading({
        text: 'Fetching enrolled Students'
      })
      try {
        this.query_page.limit = this.pageLimitSet
        const { data } = await enrolledStudentsList(
          localStorage.getItem('customer_id'),
          this.query_page,
          this.searchPayload
        )
        const table = data.data.clientUser
        this.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.students = table
        this.tableData = this.students
        //this.fetchTag(this.platform_module_id)
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    handleBulkDelete () {
      const BulkSelected = this.getSelectedRows()
      const deleting_ids = []
      for (let i = 0; i < BulkSelected.length; i++) {
        if (BulkSelected[i].basic_details.active_user === '0') {
          if (BulkSelected[i].basic_details.user_type === 'Parent') {
            if (BulkSelected[i].children.length > 0) {
              if (
                this.checkAllChildDeactive(
                  BulkSelected[i].basic_details.children
                )
              ) {
                deleting_ids.push(
                  BulkSelected[i].basic_details.client_users_id
                )
              } else {
                this.$vs.notify({
                  title: 'Warning',
                  text: 'Deactive all minor first',
                  ...this.warnProp()
                })
              }
            } else {
              deleting_ids.push(BulkSelected[i].basic_details.client_users_id)
            }
          } else {
            deleting_ids.push(BulkSelected[i].basic_details.client_users_id)
          }
        }
        // }
      }
      if (deleting_ids.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Selected rows are non-actionable',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        const payload = {
          client_user_id: deleting_ids
        }
        deleteClient(payload)
          .then((data) => {
            const table = this.tableData
            for (const delete_id_itr of deleting_ids) {
              for (let i = 0; i < table.length; i++) {
                if (delete_id_itr === table[i].basic_details.client_users_id) {
                  table.splice(i, 1)
                }
              }
            }
            table.map((row, index) => {
              row.row_index = index + 1
            })
            this.tableData = table
            this.isRowSelected = false
            this.$vs.notify({
              title: 'Success',
              text: 'Enrolled students deleted successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          .catch((e) => {})
      }
    }
  }
}
</script>

<style scoped>
</style>
